import { Carousel } from 'react-responsive-carousel';
import { useGalleryStyles } from 'components/pages/AppLibrary/styles';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { useRef, useState } from 'react';
import { Box } from '@mui/material';
import { SlideLabel } from 'components/pages/AppLibrary/components/SlideLabel';

export const SlidesGallery = ({
  showThumbs = true,
  maxWidth = '65vw',
  maxHeight,
  showArrows = false,
  thumbWidth = 200,
  content = [],
}) => {
  const videoRef = useRef();
  const [playing, setPlaying] = useState(null);

  const { classes } = useGalleryStyles({
    maxWidth,
    maxHeight,
    playing: playing !== null,
  });

  const videoHandler = (e) => {
    e.preventDefault();

    setPlaying((playingState) => {
      if (playingState) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }

      return !playingState;
    });
  };

  const isVideo = (item) => item?.includes?.('/videos/');

  return content.length ? (
    <Carousel
      showStatus={false}
      showIndicators={false}
      showArrows={showArrows}
      swipeable
      emulateTouch
      className={classes.root}
      thumbWidth={thumbWidth}
      dynamicHeight={false}
      showThumbs={showThumbs}
      renderThumbs={() =>
        content.map((item) =>
          isVideo(item) ? (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video key={item} className={classes.video}>
              <source src={item} type="video/mp4" />
            </video>
          ) : (
            <img key={item.id} src={item.image?.url} alt="slide_img" />
          ),
        )
      }
    >
      {content.map((item) =>
        isVideo(item) ? (
          <span key={item}>
            {playing === null && (
              <PlayCircleIcon
                className={classes.playButton}
                onClick={videoHandler}
              />
            )}
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              className={classes.video}
              controls
              ref={videoRef}
              onClick={videoHandler}
              onEnded={() => setPlaying(false)}
            >
              <source src={item} type="video/mp4" />
            </video>
          </span>
        ) : (
          <Box key={item.id} className={classes.slideImgWrapper}>
            <img src={item.image?.url} alt="slide_img" />
            {item.label && <SlideLabel label={item.label} />}
          </Box>
        ),
      )}
    </Carousel>
  ) : null;
};
